import { useState } from 'react';

import { xhr } from '@shared/config';
import { useAuthToken, useCookies } from '@shared/hooks';

export const useLogout = () => {
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const { removeCookie } = useCookies();
	const { removeToken } = useAuthToken();

	const logout = async () => {
		setIsLoading(true);
		try {
			await xhr.post('/api/v1/auth/rest-auth/logout/');
			removeToken();
			removeCookie('csrftoken');
			removeCookie('sessionid');
			window.location.href = '/';
		} catch (error) {}
		setIsLoading(false);
	};
	return {
		logout,
		isLoading,
	};
};
